import { useEffect, useState } from "react";
import Logo from "../../assets/img/logo2.png"
import PasswordInput from "../elements/PasswordInput";
import AppButton from "../elements/AppButton";
import LoginImage from "../../assets/img/undraw_preferences_popup_re_4qk0 _2.svg"
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { APP_STATUS, TypeDispatchResponse } from "../../helpers/constants";
import { authenticateUser } from "../../features/auth/authSlice";
import { showToastMessage } from "../../features/generalSlice";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const LoginPage =()=>{
    const [password,setPassWord] = useState("");
    const [email, setEmail]= useState("");
    const isLogingInStatus = useAppSelector(state=> state.auth.isLogingInStatus)
    const dispatch = useAppDispatch()
    const navigate = useNavigate();

    const loginUser =()=>{
        dispatch(authenticateUser({ email:email,password:password }))
        .then((response: TypeDispatchResponse)=>{
            if (response.error) {
              dispatch(showToastMessage({
                message:response.payload,
                type:"error",
                position: toast.POSITION.TOP_RIGHT
              }))
            }
          });
    }
    useEffect(()=>{
        if (isLogingInStatus ===APP_STATUS.SUCCESS) {
            navigate("/value-chains")
        }
    },[isLogingInStatus])


    return(
        <div>
        <div className=" flex items-center justify-center min-h-screen bg-gray-50">
            <div className=" w-full flex justify-center px-2 py-2">
                <div className="card sm:w-full md:w-full lg:w-full xl:w-1/3 2xl:w-1/3 3xl:w-1/3 shadow-lg rounded-lg">
                    <div className=" card-body  p-0">
                       
                        <div className="  pb-20">
                            <div className=" h-44 flex flex-col justify-center">
                                <div className=" text-center">
                                    <div className=" w-full  flex justify-center">
                                        <img className=" h-16 w-auto" src={Logo} alt="" />
                                    </div>
                                    <span className="pl-[2px] text-2xl font-bold  text-center ">ABCD PORTAL</span>
                                    <span className="pl-[2px] text-2xl font-bold  text-center ">ADMIN DASHBOARD</span>
                                </div>
                            </div>
                            <div className=" h-8 flex flex-col justify-center">
                                <div className="flex items-center px-16 ">
                                    <div className=" flex-grow border-t-[1px] border-gray-400 border-opacity-60"></div>
                                    <div className="mx-4  opacity-80 text-xs">Login</div>
                                    <div className="flex-grow  border-t-[1px] border-gray-400 border-opacity-60"></div>
                                </div>
                            </div>

                               
                            <div className=" w-full mt-4 px-5">
                                <label htmlFor="email" className="form-label-1">Email</label>
                                <div className="relative">
                                    <div className="absolute inset-y-0 left-0 flex items-center  pl-[8px] pointer-events-none">
                                        <svg aria-hidden="true" className="form-input-1-icon " fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path><path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path></svg>
                                    </div>
                                    <input value={email} onChange={(e)=> setEmail(e.target.value)} type="email" className="form-input-1 pl-10" aria-label="Email Address" placeholder="Enter your email" title="Email input field" />
                                </div>
                            </div>

                            <div className=" w-full mt-4 px-5">
                                <div className="flex">
                                    <label htmlFor="email" className="form-label-1 flex-grow">Password</label>
                                </div>
                                <PasswordInput getPasswordValue={(password)=>setPassWord(password)}/>
                            </div>
                        
                            <div className="w-full mt-5 px-5">
                                <AppButton callBackFun={()=>loginUser()} showLoader={isLogingInStatus===APP_STATUS.PENDING}  spinnerClass="inline w-3 h-3 mr-2 text-prim-yellow animate-spin fill-black" className="prim-btn-2 w-full" text="Login" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
}

export default LoginPage;